/**
 * [2026-09-11] 방문 추적 비콘 — 로그인 회원의 페이지 체류/방문을 백엔드(visit_log)로 전송.
 *   정책: ★로그인 회원만(토큰 있을 때만) 전송 — 익명 방문은 기록하지 않음(영업적 '회원' 동향 분석 목적).
 *   기기·IP는 백엔드가 요청 헤더에서 판별(여기선 path·dwellMs만 전송, 조작 방지).
 *   keepalive:true 로 페이지 이탈(pagehide) 중에도 전송 보장. 실패는 조용히 무시(UX 영향 0).
 *   연관: App.tsx VisitTracker(호출부), server VisitController.
 */
import { getToken } from './authApi';

const API = import.meta.env.DEV ? 'http://localhost:8081' : '';

export function recordVisit(path: string, dwellMs: number) {
	const t = getToken();
	if (!t) return;                          // 비로그인 → 미기록
	if (!path || dwellMs < 0) return;
	try {
		fetch(API + '/api/web/visit', {
			method: 'POST',
			keepalive: true,                 // 이탈 중에도 전송 보장
			headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${t}` },
			body: JSON.stringify({ path, dwellMs }),
		}).catch(() => { /* noop */ });
	} catch { /* noop */ }
}
